import React from 'react';

import './GamePage.css';
import GameComponent from "../componetns/game/GameComponent";
import {HTML5Backend} from "react-dnd-html5-backend";
import {TouchBackend} from 'react-dnd-touch-backend'
import {DndProvider} from "react-dnd";
import {isMobile} from 'react-device-detect';
import {useActions} from "../hooks/useActions";
import {useTypedSelector} from "../hooks/useTypedSelector";

function GamePage() {

    const {battleBg} = useTypedSelector(state => state.game);
    const {setTouchDragCoords} = useActions();
    const handleToucheMove = (e) => {

        const gameHeight = window.innerHeight;
        const invertZoom= (100 - Math.round((6/35) * gameHeight - 3.71)) / 100;
        const clientX = (e.touches[0].clientX * invertZoom) + e.touches[0].clientX;
      //  const clientY =   e.touches[0].clientY - (e.touches[0].clientY * (invertZoom / 2));
        const clientY =   e.touches[0].clientY;

        console.log('start ' + clientX + ' - ' + clientY);

        setTouchDragCoords({x: clientX, y: clientY})
    };

    return (
        isMobile ? (
                <div className={"game-container " + battleBg} onTouchMove={handleToucheMove}>
                    <DndProvider backend={TouchBackend}>
                        <GameComponent/>
                    </ DndProvider>
                </div>)
            :
            (<div className={"game-container " + battleBg}>
                <DndProvider backend={HTML5Backend}>
                    <GameComponent/>
                </ DndProvider>
            </div>)
    );
}

export default GamePage;